import React, { Component } from 'react';
import BasicPage from '../../components/basicpage';

export default class extends Component {
  render() {
    return (
      <BasicPage>
        <h2>Data Sources</h2>
        <p>Dwellist aggregates data from the following publicly available sources:</p>
        <ul>
          <li><a href="https://data.gov.ie/dataset/small-areas-ungeneralised-osi-national-statistical-boundaries">LEA geojson boundaries (Ungeneraised)</a></li>
          <li><a href="https://data.gov.ie/dataset/local-electoral-areas-boundaries-ungeneralised-osi-national-administrative-boundaries">Small area geojson boundaries (Ungeneralised)</a></li>
          <li><a href="https://data.gov.ie/dataset/noise-maps-from-traffic-sources-in-dublin-city-council">Traffic noise in Dublin</a></li>
          <li><a href="http://www.cso.ie/en/census/census2016reports/census2016smallareapopulationstatistics/">2016 Census</a></li>
          <li><a href="https://onestopshop.rtb.ie/research/about-the-rent-index">Rent Index</a></li>
          <li><a href="https://www.propertypriceregister.ie">Property Price Register</a></li>
          <li><a href="https://www.autoaddress.ie/blog/autoaddressblog/2016/09/21/eircode-routing-keys">Eircode routing keys</a></li>
          <li><a href="https://www.cso.ie/StatbankServices/StatbankServices.svc/jsonservice/responseinstance/CJA07">Crime stats</a></li>
          <li><a href="https://services6.arcgis.com/uWTLlTypaM5QTKd2/ArcGIS/rest/services/CrimeStats/FeatureServer/12">Crime boundaries</a></li>
          <li><a href="https://www.cso.ie/StatbankServices/StatbankServices.svc/jsonservice/responseinstance/HPM02">Property stats</a></li>
          <li><a href="https://data-osi.opendata.arcgis.com/datasets/small-areas-ungeneralised-osi-national-statistical-boundaries/geoservice">Small area features</a></li>

        </ul>
      </BasicPage>
    )
  }
}


// WEBPACK FOOTER //
// ./src/pages/sources/index.js